import * as yup from 'yup';
import { PackageSize, values } from '../../../enums';
import { IResident } from '../../resident-creation';
import { IOrder } from './IOrder';

export const CreateGeneralOrderSchema = yup.object({
  residentId: yup.string().required(),
  doctorId: yup.string().required(),
  order: yup.string().required(),
  note: yup.string().nullable(),
  packageSize: yup
    .mixed<PackageSize>()
    .oneOf([...values(PackageSize)])
    .nullable(),
});

export interface IGeneralOrder extends IOrder {
  packageSize?: PackageSize;
  resident: IResident;
}

export interface ICreateGeneralOrder extends Pick<IGeneralOrder, 'order' | 'note' | 'packageSize'> {
  residentId: string;
  doctorId: string;
}
